import axios from "axios";
import {
  HIDE_CLUSTER_NODE_REQUEST,
  HIDE_CLUSTER_NODE_SUCCESS,
  HIDE_CLUSTER_NODE_FAILURE,
} from "../types/clusterNodeTypes";

export const hideClusterNode = (data: []) => {
  return async (dispatch: any) => {
    dispatch({ type: HIDE_CLUSTER_NODE_REQUEST });

    try {
      dispatch({
        type: HIDE_CLUSTER_NODE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: HIDE_CLUSTER_NODE_FAILURE,
        payload: [],
      });
    }
  };
};
